var render = function (_h,_vm) {var _c=_vm._c;return _c('main',{class:[
    _vm.data.staticClass,
    'v-content',
    _vm.props.size ? ("v-content--" + (_vm.props.size)) : '',
    {
      'v-content--no-side-padd': _vm.props.noSidePadd,
    } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }